var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle4D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M486.6,155.9c-0.8-1.7-1.7-3.3-2.7-4.8c-3.7-5.7-8.6-10.6-15.1-13.6c2.7-7.6-2.4-16.8-8.4-22.1 c-10.9-8.9-23.4-15.5-36.7-19.3c-2.6-0.8-5.3-1.4-8.1-1.9c-9-2.3-18.1-3.7-27.3-4.4c-3-0.2-6.1-0.4-9.2-0.5 c-20.5-0.4-41.8,1-62.3,6c-2.9,0.7-5.8,1.5-8.7,2.3c-27.2,9.2-53.4,25.1-63.4,50.4c-1,2.2-2,4.5-2.8,6.7 c-1.3,3.4-2.4,6.9-3.3,10.5c-3.2,12.3-3.6,24.5-1.8,36.6c0.4,2.4,0.8,4.8,1.3,7.2c3.3,17.3,11.5,33.2,16.9,49.7 c0-20.1,9.9-40,28.2-52.4c20.4-13.8,43.6-27.3,67.6-34.9c-20.9,12.2-37.6,23.8-56.5,34.5c17-2.1,27.8-5.4,41.6-9.9 c12.5-4.1,33.8-10.3,44.3-17.6c-16.4,12-32.7,25.4-53.4,31.4c12.9,1.7,28.6-2.7,40.8-6.4c13.1-4,22.5-7.7,35.3-12.8 c8.7-3.4,27.6-11.4,38.4-18c12.3,14,13.5,33.4,15.5,50.2c0.2,2.1,0.3,4.1,0.5,6.2c0.4,4.1,0.8,8.2,1.6,12.2 c0.3,1.7,0.5,3.4,0.8,5.2c0.9,6.1,2,12.6,4.2,18.7c1.7-10.1,5.9-19.2,11.1-28c0.9-1.5,1.8-3.1,2.8-4.6c5-6.1,8.1-12.6,10.2-19.4 c0.5-1.7,1-3.4,1.4-5.1C492.5,190.9,496,171.7,486.6,155.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#87634D",
    d: "M348.7,105.8c-37.4,3.4-68.3,23.2-88.5,52c-19.7,30.4-16.9,64.8-4.8,94.1c0.5-4.3,1.4-8.6,2.8-12.7 C240.7,174.5,285.7,120.9,348.7,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87634D",
    d: "M312,175.1c4.4-2.2,11.6-5.5,16.2-7.4c31.3-13.7,71.3-20.6,87-47c-28.5,18.1-63,21.3-93.4,34.7 c-5.2,2.3-10.3,4.7-15.2,7.4c-28.1,15.4-49.4,37.7-45.3,68.6c2.9-5.8,6.6-11.2,11.3-16C279.2,196.9,293.7,184.4,312,175.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#87634D",
    d: "M451.1,144.1c-28.7,22.8-62.2,38.4-96.2,52.5c-8.7,5.5-17.8,10.4-28.1,13.3c12.9,1.7,28.6-2.7,40.8-6.4 c13.1-4,22.5-7.7,35.3-12.8c3.4-1.4,8.5-3.4,14-5.8C430.9,173.4,442.7,159.6,451.1,144.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle4D);
export default __webpack_public_path__ + "static/media/man_hairstyle_4d.03c9ba9a9b258d1c08bbeeeb2cf15199.svg";
export { ForwardRef as ReactComponent };